import React from 'react';
import { useTranslation } from 'react-i18next';
import { VStack } from '@/components/gluestack/vstack';
import { Text } from '@/components/gluestack/text';
import { Button, ButtonText } from '@/components/gluestack/button';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { LinkSquare02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useCommunity } from '@/hooks/useCommunity';
import { ExternalLinkButton } from '@/components/ui/ExternalLinkButton';
import { useSupportService } from '@/hooks/useSupportService';
import { BILLING_URLS } from '@/constants/urls';
import type { CommunityCode } from '@/constants/communities';

/** Billing information blurb with links to the billing guide and billing support (no card chrome). */
export function BillingFaq() {
  const { t } = useTranslation();
  const community = useCommunity();
  const { submitBillingSupport } = useSupportService();

  const billingUrl = community ? BILLING_URLS[community.code as CommunityCode] : undefined;

  return (
    <VStack space="md">
      <Text size="sm" className="text-typography-600">
        {t('account.plans.billingFaqDescription', { planName: community?.premiumPlan })}
      </Text>

      <VStack space="xs">
        <ExternalLinkButton
          url={billingUrl}
          label={t('account.plans.billingFaqGuide', { planName: community?.premiumPlan })}
        />

        {/* Not a plain link: the form URL comes from a support request created on tap */}
        <Button
          variant="link"
          action="primary"
          onPress={submitBillingSupport}
          className="self-start">
          <HugeIconsWrapper icon={LinkSquare02Icon} size={18} className="color-primary-500" />
          <ButtonText className="text-primary-500">
            {t('account.plans.getBillingSupport')}
          </ButtonText>
        </Button>
      </VStack>
    </VStack>
  );
}
